import { Locale } from 'date-fns';
import deLocale from 'date-fns/locale/de';
import { useTranslation } from 'react-i18next';

/**
 * Returns the date-fns locale based on the currently selected language. If no locale matches the
 * language, the German locale is returned. The locale can be used to format dates.
 * <p>
 * Note that the date can also be formatted using i18n interpolation, which will probably be
 * the easier way: `t('KEY', { date })`.
 *
 * @example
 * const locale = useLocale();
 * const dateStr = format(date, t('DATE_FORMAT'), { locale });
 */
export function useLocale(): Locale {
  const { i18n } = useTranslation();
  return (i18n.getResource(i18n.language, 'locale', '') || deLocale) as Locale;
}
